<script setup>
import { computed, inject } from 'vue';
import { Handle, Position } from '@vue-flow/core';

const props = defineProps({
  nodeId: { type: String, required: true },
  selected: { type: Boolean, default: false },
  icon: { type: String, required: true },
  typeLabel: { type: String, required: true },
  // Named nodeLabel, not label: Vue Flow passes its own (undefined) `label`
  // to custom nodes, which falls through and overrides an explicit binding.
  nodeLabel: { type: String, default: '' },
  accentClass: { type: String, required: true },
  hasTarget: { type: Boolean, default: true },
  hasSource: { type: Boolean, default: true },
});

const simulator = inject('sopSimulator', null);

const isCurrent = computed(
  () => simulator?.state.value.currentNodeId === props.nodeId
);
</script>

<template>
  <div
    class="w-72 rounded-xl border bg-n-solid-2 shadow-sm transition-shadow"
    :class="[
      selected ? 'border-n-brand ring-2 ring-n-brand/30' : 'border-n-weak',
      isCurrent ? 'ring-2 ring-n-teal-9 border-n-teal-9' : '',
    ]"
  >
    <Handle v-if="hasTarget" type="target" :position="Position.Left" />
    <div class="flex items-center gap-3 px-4 py-3">
      <span
        class="flex size-8 shrink-0 items-center justify-center rounded-md"
        :class="accentClass"
      >
        <span :class="icon" class="size-4" />
      </span>
      <p class="mb-0 text-xs uppercase tracking-wide text-n-slate-10">
        {{ typeLabel }}
      </p>
    </div>
    <p
      v-if="nodeLabel"
      class="-mt-1 mb-0 whitespace-pre-wrap break-words px-4 pb-3 text-base font-semibold text-n-slate-12"
    >
      {{ nodeLabel }}
    </p>
    <slot />
    <Handle v-if="hasSource" type="source" :position="Position.Right" />
  </div>
</template>
